import { render, staticRenderFns } from "./FourIntro.vue?vue&type=template&id=73d0a504&scoped=true&"
import script from "./FourIntro.vue?vue&type=script&lang=js&"
export * from "./FourIntro.vue?vue&type=script&lang=js&"
import style0 from "./FourIntro.vue?vue&type=style&index=0&id=73d0a504&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d0a504",
  null
  
)

export default component.exports